const content = {
    info: "Strona wykorzystuje pliki cookies.",
    more: "więcej informacji",
    agree: "rozumiem"
}

export default content
